
@switch (mode) {
  @case (LabelMode.DEFAULT) {
    <ng-container
      [ngTemplateOutlet]="default"
    ></ng-container>
  }
  @case (LabelMode.INLINE) {
    <ng-container
      [ngTemplateOutlet]="inline"
    ></ng-container>
  }
  @case (LabelMode.NO_LABEL) {
    <ng-container
      [ngTemplateOutlet]="input"
    ></ng-container>
  }
}

<ng-template #input>
  <div class="input-group datepicker-group">
    <!-- Theme style -->
    <input
      ngbDatepicker
      #d="ngbDatepicker"
      rInputMask="99/99/9999"
      [type]="clearable ? 'search' : 'text'"
      class="form-control"
      [ngClass]="{ 'is-invalid': isError }"
      [name]="name"
      [placeholder]="placeholder | translate"
      [formControl]="form"
      [firstDayOfWeek]="7"
      [minDate]="minPDate"
      [maxDate]="maxPDate"
      (click)="d.toggle()"
      />
    <!-- Default style -->
    <!-- <input
    ngbDatepicker
    #d="ngbDatepicker"
    rInputMask="99/99/9999"
    [type]="clearable ? 'search' : 'text'"
    class="form-control"
    [ngClass]="{ 'is-invalid': isError }"
    [name]="name"
    [placeholder]="placeholder | translate"
    [formControl]="form"
    [firstDayOfWeek]="7"
    [minDate]="minPDate"
    [maxDate]="maxPDate"
    (click)="d.toggle()"
    /> -->
    <div class="input-group-append">
      <span
        class="input-group-text cursor-pointer picker-button"
        (click)="d.toggle()"
        [ngClass]="{ disabled: form.disabled, 'is-invalid': isError }"
        >
        <app-keenicon
          name="calendar"
          class="fs-1 cursor-pointer"
        ></app-keenicon>

        <!-- <span [data-feather]="'calendar'" [size]="16"></span> -->
      </span>
    </div>
  </div>
  <!-- <div>
  <nz-date-picker name="basicDate" [ngClass]="{'is-invalid': isError}" [formControl]="form" [nzFormat]="format" [nzPlaceHolder]="placeholder | translate" [nzDisabledDate]="disabledDate" [nzShowToday]="showToday"></nz-date-picker>
</div> -->
<ng-container [ngTemplateOutlet]="error"></ng-container>
</ng-template>

<ng-template #default>
  <div class="form-group" [ngClass]="classes">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}
      <ng-container [ngTemplateOutlet]="subLabel"></ng-container
      ></label>
      <ng-container [ngTemplateOutlet]="input"></ng-container>
    </div>
  </ng-template>

  <ng-template #inline>
    <div class="form-group form-group-inline" [ngClass]="classes">
      <label
        [for]="name"
        class="col-form-label fw-bold fs-6 py-2"
        [ngClass]="required ? 'required' : ''"
        >{{ label | translate }}
        <ng-container [ngTemplateOutlet]="subLabel"></ng-container
        ></label>
        <ng-container [ngTemplateOutlet]="input"></ng-container>
      </div>
    </ng-template>

    <ng-template #error>
      @if (isError) {
        <span class="error">{{ errorMessage | translate }}</span>
      }
    </ng-template>

    <ng-template #subLabel>
      @if (addonLabel != '') {
        <span class="text-muted">
          - {{ addonLabel | translate : { year: currentYear } }}</span
          >
        }
      </ng-template>
